import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ScrumboardService } from 'app/main/pages/scrumboard/scrumboard.service';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { ToastrService } from 'ngx-toastr';
import { ProjectDataService } from '../project-information/project-data.service';

@Component({
  selector: 'app-project-information-stepper',
  templateUrl: './project-information-stepper.component.html',
  styleUrls: ['./project-information-stepper.component.scss']
})

export class ProjectInformationStepperComponent implements OnInit {

  projectInfoForm: FormGroup;
  projectId: string;
  clientList: any = [];
  tenantId: string;
  billingType: any = [];
  sprintId: string;
  @ViewChild('stepper', { static: false }) stepper: MatStepper;
  isCreate = true;
  nonBillableCount: any;
  billableCount: any;
  totalBillableCount: any;
  isOnHold: boolean = false;

  projectStatus: any = [
    { name: 'New' },
    { name: 'In Progress' },
    { name: 'On Hold' },
    { name: 'Completed' },
    { name: 'Rejected' }
  ]

  constructor(
    private fb: FormBuilder,
    private queryInterface: QueryInterface,
    private storageConfiguration: StorageConfiguration,
    private parseService: ParseService,
    private activityCenterService: ActivityCenterService,
    private route: ActivatedRoute,
    private projectDataService: ProjectDataService,
    private _scrumboardService: ScrumboardService,
    private toaster: ToastrService,
    private router: Router,
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.billingType = this.projectDataService.billingTypeData;
  }

  ngOnInit() {
    this.createForm();
    this.getClient();
    this.route.params.subscribe((params) => {
      this.projectId = params['id'];
      this.isOnHold = Boolean(params['isOnHold']);
      if (this.projectId) {
        this.isCreate = false;
        this.patchProject();
      }
    });

    this.getProjectMemberCount();
  }

  createForm(): void {
    this.projectInfoForm = this.fb.group({
      projectName: ['', Validators.required],
      billingType: ['', Validators.required],
      projectDescription: [''],
      clientName: [''],
      projectStartDate: [],
      projectEndDate: [],
      projectStatus: ['']
    });
  }

  async saveProjectDetails(): Promise<void> {
    if (this.isCreate) {
      await this.createProject();
      // this.goForward();
    }
    else {
      if (!this.projectInfoForm.pristine) {
        this.projectInfoForm.reset(this.projectInfoForm.value);
        this.updateProject();
        // this.goForward();
      }
      else {
        // this.goForward();
      }
    }
  }

  patchProject() {
    if (this.projectId) {
      const Project = this.parseService.instance.Object.extend('Project');
      const projectQuery = new this.parseService.instance.Query(Project);
      projectQuery.equalTo('objectId', this.projectId);
      projectQuery.find().then((projectResult) => {
        this.projectInfoForm.patchValue({
          projectName: projectResult[0].get('projectInfo').projectName,
          projectDescription: projectResult[0].get('projectInfo').projectDescription,
          clientName: projectResult[0].get('client').id,
          billingType: projectResult[0].get('projectInfo').projectType,
          projectStatus: projectResult[0].get('projectInfo').currentStatus,
        });
      });
    }

  }

  /*
 ** ==========================================================
 ** Get Client Details
 ** ==========================================================
 */
  getClient(): void {
    let clientName = [];
    const result = [];
    this.queryInterface.executeQuery(this.parseService, 'Client',
      [{ field: 'name', condition: 'descending' }, { condition: 'limit', value: 10000 }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      ]).then(results => {
        const jsonText = JSON.stringify(results);
        const clients = JSON.parse(jsonText);
        for (const client of clients) {
          clientName = client.companyInfo.firstName ? client.companyInfo.firstName : ' ';
          this.clientList.push({
            id: client.objectId,
            name: clientName.concat(' ' + client.companyInfo.lastName)
          });
        }
      });
  }

  async createProject() {
    const projectValues = this.projectInfoForm.value;
    const resourceDetails = {
      id: this.getRandomNumber(9),
      details: [
        {
          "id": this.getRandomNumber(9),
          "role": "PM",
          "count": 1,
          "hours": 10
        },
        {
          "id": this.getRandomNumber(9),
          "role": "Full-Stack",
          "count": 10,
          "hours": 100
        }
      ],
      resourceDetailDate: new Date()
    };
    const data = {
      projectInfo: {
        clientName: projectValues.clientName,
        projectDescription: projectValues.projectDescription,
        projectName: projectValues.projectName,
        projectType: projectValues.billingType,
        addOnType: '',
        currentStatus: 'New',
        projectPlatform: [],
        reason: '',
        projectStartDate: new Date(),
        actualCompletionDate: new Date(),
        extendedCompletionDate: new Date(),
        srs: [],
        plan: [],
      },
      resourceDetails: resourceDetails
    };

    let activities = [];
    let message = 'Created a Project ' + projectValues.projectName;
    let activity = this.activityCenterService.setActivityModel(message);
    activities.push(activity);

    const ProjectClass = this.parseService.instance.Object.extend('Project');
    var projectDetails = new ProjectClass();
    projectDetails.set('projectInfo', data.projectInfo);
    projectDetails.set('client', { __type: 'Pointer', className: 'Client', objectId: projectValues.clientName ? projectValues.clientName : undefined });
    projectDetails.set('comments', []);
    projectDetails.set('projectType', 'Project');
    projectDetails.set('isActive', true);
    projectDetails.set('resourceDetails', resourceDetails);
    projectDetails.set('defaultProject', false);
    projectDetails.set('activities', activities);
    projectDetails.set('tenantId', this.tenantId);
    projectDetails.set('schedulerStatus', projectValues.billingType);

    await projectDetails.save().then(async (data) => {
      this.toaster.success('Project Created Successfully');
      this.projectId = data.id;
      this.router.navigate(['project-detail', { id: this.projectId, projectType: 'Project' }]);
      await this._scrumboardService.createScrumBoard(this.projectId, false).then(data => {
        this.sprintId = data.id;
      });
    }).catch(() => {
      this.toaster.success('Project Create Failed');
    });
  }

  getRandomNumber(val) {
    const timestamp = +new Date();
    length = val;
    var ts = timestamp.toString();
    var parts = ts.split('').reverse();
    var id = '';

    for (var i = 0; i < length; ++i) {
      var index = this.generateRandomNumber(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }

  generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  goForward(stepper?: MatStepper): void {
    this.stepper.next();
  }
  goBack(stepper: MatStepper): void {
    this.stepper.previous();
  }

  async updateProject() {
    const projectValues = this.projectInfoForm.value;
    let Project = this.parseService.instance.Object.extend('Project');
    let projectQuery = new this.parseService.instance.Query(Project);
    projectQuery.equalTo('objectId', this.projectId);
    let result = await projectQuery.find();
    let updateProjectInfo = result[0];
    let projectInfo = updateProjectInfo.attributes.projectInfo;
    projectInfo.projectName = projectValues.projectName;
    projectInfo.clientName = projectValues.clientName;
    projectInfo.projectDescription = projectValues.projectDescription;
    projectInfo.projectType = projectValues.billingType;
    projectInfo.currentStatus = projectValues.projectStatus;

    updateProjectInfo.set('projectInfo', projectInfo);
    updateProjectInfo.set('schedulerStatus', projectValues.billingType);
    updateProjectInfo.set('client', { __type: 'Pointer', className: 'Client', objectId: this.projectInfoForm.value.clientName ? this.projectInfoForm.value.clientName : undefined ? projectValues.clientName : undefined });
    updateProjectInfo.save();
    this.toaster.success('Project update Successfully');
  }


  async getProjectMemberCount() {
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    query.equalTo('status', 'Assigned');
    query.equalTo('tenantId', this.tenantId);
    let projectMembersDetails = await query.find();
    if (projectMembersDetails.length > 0) {

      this.billableCount = 0;
      this.nonBillableCount = 0;

      for (let data of projectMembersDetails) {
        let isBillable = data.get('isBillable') ? data.get('isBillable') : false;
        if (isBillable) { this.billableCount = this.billableCount + 1; }
        else { this.nonBillableCount = this.nonBillableCount + 1; }
      }
      this.billableCount = this.billableCount == 10 ? this.billableCount : this.billableCount < 10 ? '0' + this.billableCount : this.billableCount;
      this.nonBillableCount = this.nonBillableCount == 10 ? this.nonBillableCount : this.nonBillableCount < 10 ? '0' + this.nonBillableCount : this.nonBillableCount;
      this.totalBillableCount = Number(this.billableCount) + Number(this.nonBillableCount);
      this.totalBillableCount = this.totalBillableCount == 10 ? this.totalBillableCount : this.totalBillableCount < 10 ? '0' + this.totalBillableCount : this.totalBillableCount;

      // let Project = this.parseService.instance.Object.extend('Project');
      // let project = new this.parseService.instance.Query(Project);
      // project.equalTo('objectId', this.projectId);
      // let result = await project.find();
      // let projectInfo = result[0];
      // projectInfo.set('billable', this.billableCount);
      // projectInfo.set('nonBillable', this.nonBillableCount);
      // projectInfo.set('totalBillable', this.totalBillableCount);
      // let projectDetails = projectInfo.save();
      // if (projectDetails.length > 0) {
      //   this.toaster.success('Project Billing updated!!')
      // }
    }
  }


}
